/**
 * `App.recaptchaSiteKey` is exposed whenever the invisible captcha is enabled
 * for *any* flow, so its presence must not be used as a per-flow on/off
 * switch: executing the captcha for a flow the server doesn't verify blocks
 * that form on a token Google may never deliver.
 *
 * Mirrors the server-side gating in Captcha::forLogin()/forRegister().
 */
export function recaptchaSiteKeyFor(flow: 'login' | 'register'): string | null {
   const enabled =
      flow === 'login' ? App.recaptchaEnabledForLogin : App.recaptchaEnabledForRegister;
   return enabled ? App.recaptchaSiteKey || null : null;
}
